module.exports = __webpack_public_path__ + "img/Cooking-Recipe.9195bc62.png";